import { useEffect, useState } from "react"

import "../styles/views/niosome.css"

import MoreInfo from "../components/MoreInfo";
import OtherProduct from "../components/OtherProduct";

//icon liposome actif
import left_schema from "../assets/img/niosome_schema.png";
import bottom_schema from "../assets/icons/liposome_botom_schema.png";

//icon otherProduct
import probiotique from "../assets/icons/homepage_probiotique.png";
import liposome from "../assets/icons/homepage_liposome.png";

//icon gamme
import gamme1 from "../assets/icons/vitamine_gamme.png";
import gamme2 from "../assets/icons/acide_gamme.png";
import gamme3 from "../assets/icons/vegetaux_gamme.png";

//icon explication
import schema_right from "../assets/img/schema_right_niosome.png";
import schema_left2 from "../assets/img/schema_left_niosome2.png";
import schema_left from "../assets/img/schema_left_niosome.png";

//icon carousel
import icon_arrow_forward from '../assets/icons/arrow_forward.svg';
import icon_arrow_back from '../assets/icons/arrow_back.svg';

import intro_niosome from "../assets/img/intro_niosome.png";
import TabNiosomeProduct from "../components/TabNiosomeProduct"
import TabCatalogue from "../components/TabCatalogue";
import produits from "../assets/ProductContent/data/data.js";


export default function Niosome() {

    const [isMobile, setIsMobile] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? gamme.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === gamme.length - 1 ? 0 : prevIndex + 1
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1050);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const gamme = [
        [gamme1, "Vitamins & minerals", "Biotin, Niacinamide,<br/> Vitamins A, C, E, Zinc..."],
        [gamme2, "Acids & PEPTIDES", "HYALURONIC ACID, COLLAGEN,<br/> CLYCOLIC ACID..."],
        [gamme3, "plants & antioxidants", "CurcuMINE, CAFFEINE, Cinnamon,<br/> GARNICIA, EGCG, Glutathione..."]
    ];


    return (
        <div>
            <div className="niosome_global-container">
                {isMobile ? (
                    <section className="niosome_intro-container">
                        <h1 className="niosome_intro-title"><label className="bold font-42">Your supplier of</label><br /><label className="orange-color">niosomal active <br /> ingredients</label></h1>
                        <img className="niosome_intro-img" src={intro_niosome} />
                        <p className="niosome_intro-subtitle"><label className="orange-color">Niosomal technology </label>for highly effective cosmetics</p>
                        <p className="niosome_intro-text">
                            Niosomal technology represents a major advance in cosmetics, offering greater efficiency and targeted penetration of active ingredients.
                            <br /><br />
                            Thanks to niosomes, small spherical structures capable of encapsulating ingredients, this technology guarantees deep and prolonged diffusion of active ingredients into the skin's layers.
                            It also preserves their stability and integrity, even for the most delicate ingredients.
                            <br /><br />
                            Unlike traditional formulations, cosmetic products enriched with niosomes offer  rapid, long-lasting action, that is perfectly adapted to the skin's needs, while respecting its natural sensitivity.
                            <br /><br />
                            Offer your customers an exceptional cosmetic experience thanks to this high-performance scientific innovation.
                        </p>
                        <MoreInfo
                            label={"See our catalogue"}
                            link={"download"}
                        />
                    </section>
                ) : (
                    <section className="niosome_intro-container">
                        <div className="niosome_intro_content-container">
                            <h1 className="niosome_intro-title"><label className="bold font-42">Your supplier of</label><br /><label className="orange-color">niosomal active <br /> ingredients</label></h1>
                            <p className="niosome_intro-subtitle"><label className="orange-color">Niosomal technology </label>for highly effective cosmetics</p>
                            <p className="niosome_intro-text">
                                Niosomal technology represents a major advance in cosmetics, offering greater efficiency and targeted penetration of active ingredients.
                                <br /><br />
                                Thanks to niosomes, small spherical structures capable of encapsulating ingredients, this technology guarantees deep and prolonged diffusion of active ingredients into the skin's layers.
                                It also preserves their stability and integrity, even for the most delicate ingredients.
                                <br /><br />
                                Unlike traditional formulations, cosmetic products enriched with niosomes offer  rapid, long-lasting action, that is perfectly adapted to the skin's needs, while respecting its natural sensitivity.
                                <br /><br />
                                Offer your customers an exceptional cosmetic experience thanks to this high-performance scientific innovation.
                            </p>
                            <MoreInfo
                                label={"See our catalogue"}
                                link={"download"}
                            />
                        </div>
                        <img className="niosome_intro-img" src={intro_niosome} />
                    </section>
                )}
                <section className="niosome_gamme-container">
                    <h2 className="niosome_gamme-title">a wide <label className="orange-color">range of active ingredients</label></h2>
                    <p className="niosome_gamme-subtitle">Our laboratory offers a a complete range of niosomal active ingredients specially formulated for cosmetics. All our ingredients are carefully selected to meet the high expectations of professionals and their consumers:</p>
                    <div className="niosome_gamme_icon-container">
                        {isMobile ? (
                            // 📱 Mode Carousel (Mobile)
                            <div className="carousel_container">
                                <img className="carousel_arrow left" src={icon_arrow_back} alt="Flèche gauche" onClick={handlePrev} />

                                <div className="carousel_item">
                                    <img className="niosome_gamme-img" src={gamme[currentIndex][0]} alt={gamme[currentIndex][1]} />
                                    <p className="niosome_gamme-item-title">{gamme[currentIndex][1]}</p>
                                    <p className="niosome_gamme-item-subtitle" dangerouslySetInnerHTML={{ __html: gamme[currentIndex][2] }}></p>
                                </div>

                                <img className="carousel_arrow right" src={icon_arrow_forward} alt="Flèche droite" onClick={handleNext} />
                            </div>
                        ) : (
                            <div className="niosome_gamme_icon-container">
                                <div className="niosome_gamme_icon-item">
                                    <img className="niosome_gamme-img" src={gamme1} />
                                    <p className="niosome_gamme-item-title">Vitamins & minerals</p>
                                    <p className="niosome_gamme-item-subtitle">Biotin, Niacinamide, <br /> Vitamins A, C, E, Zinc...</p>
                                </div>
                                <div className="niosome_gamme_icon-item">
                                    <img className="niosome_gamme-img" src={gamme2} />
                                    <p className="niosome_gamme-item-title">Acids & PEPTIDES</p>
                                    <p className="niosome_gamme-item-subtitle">HYALURONIC ACID, COLLAGEN,<br /> CLYCOLIC ACID...</p>
                                </div>
                                <div className="niosome_gamme_icon-item">
                                    <img className="niosome_gamme-img" src={gamme3} />
                                    <p className="niosome_gamme-item-title">plants & antioxidants</p>
                                    <p className="niosome_gamme-item-subtitle">CurcuMINE, CAFFEINE, Cinnamon,<br />GARNICIA, EGCG, Glutathione...</p>
                                </div>
                            </div>
                        )}
                    </div>
                    <MoreInfo
                        label={"see our catalogue"}
                        link={"download"}
                    />
                </section>
                <section className="niosome_presentation-container">
                    <h2 className="niosome_presentation-title">what is a <label className="orange-color">niosome ?</label></h2>
                    <p className="niosome_presentation-text">
                        <label className="">Niosomes are non-ionic encapsulation systems designed to improve the release of active ingredients into the skin. Thanks to their unique structure, they effectively encapsulate ingredients, enabling controlled release and improved penetration into the skin. The result is a significant increase in the efficiency of cosmetic products, while ensuring optimum protection of sensitive active ingredients.</label>
                    </p>
                    <div className="niosome_presentation_schema-container">
                        <div className="niosome_presentation_leftSchema-container">
                            <img className="niosome_presentation_leftSchema-img" src={schema_left2} />
                        </div>
                        <div className="niosome_presentation_rightSchema-container">
                            <h3 className="niosome_presentation_rightSchema-title">The benefits of <label className="orange-color">niosomal <br />active ingredients</label></h3>
                            <div className="niosome_presentation_rightSchema-img">
                                <img className="niosome_presentation_rightchema-img" src={schema_right} />
                            </div>
                            <p className="niosome_presentation_rightSchema-text">Niosomal technology offers numerous benefits for your dietary supplement formulations :</p>
                            <p className="niosome_presentation_bulletPoint-text"><label className="bold orange-color upppercase">✓ Powerful, deep and effective :</label> Optimal penetration for visible, long-lasting results.
                            </p>
                            <p className="niosome_presentation_bulletPoint-text"><label className="bold orange-color upppercase">✓ Long-lasting action: Controlled & prolonged release :</label> Active ingredients that work for your skin all day long.</p>
                            <p className="niosome_presentation_bulletPoint-text"><label className="bold orange-color upppercase">✓ Best stability of active ingredients :</label> A formula that preserves the strength of the active ingredients for optimal effectiveness.
                            </p>
                            <p className="niosome_presentation_bulletPoint-text"><label className="bold orange-color upppercase">✓ Biocompatible & skin-friendly :</label> Gentle active ingredients that are suitable for even the most sensitive skin.</p>
                        </div>
                    </div>
                </section>
                <section className="niosome_listingMp-container">
                    <TabCatalogue produits={produits} type="niosome" />
                </section>
                <section className="niosome_listingMp-container">
                    <TabNiosomeProduct />
                    <MoreInfo
                        label={"Contact us"}
                        link={"*"}
                    />
                </section>
                <section className="liposome_choice_global-container">
                    <h3 className="liposome_choice-title">Why choose our <label className="orange-color">niosomal active <br /> ingredients ?</label></h3>
                    <div className="niosome_choice-container-intro">
                        <div className="niosome_choice-container-intro-item">
                            <h3 className="niosome_choice-title-intro">For our  <label className="orange-color">expertise</label></h3>
                            <p className="niosome_choice-text-intro">
                                We work closely with experts in dermatology and cosmetic formulation to create products that meet the specific needs of our customers.
                                Our development process incorporates the latest scientific advances to guarantee unprecedented results.
                            </p>
                        </div>
                        <div className="niosome_choice-container-intro-item">
                            <h3 className="niosome_choice-title-intro">For our <label className="orange-color">commitments</label></h3>
                            <p className="niosome_choice-text-intro">
                                <label className="orange-color uppercase bold">✓ innovation </label>: we are committed to developing cutting-edge solutions that set new standards in the cosmetics industry.
                                <br /><br />
                                <label className="orange-color uppercase bold">✓ quality </label>:Each product is the result of in-depth research and rigorous quality control, guaranteeing safety and efficiency.
                                <br /><br />
                                <label className="orange-color uppercase bold">✓ personalisation </label>: we offer tailor-made services to meet the unique requirements of each brand, enabling it to stand out from the crowd, from raw materials to finished products.
                            </p>
                        </div>
                    </div>
                    <div className="liposome_choice-2bloc-container">
                        <div className="liposome_choice-leftBloc-container">
                            <h4 className="liposome_choice-leftBloc-title"><label className="orange-color">flexible </label> tailor-made production</h4>
                            <p className="liposome_choice-leftBloc-text">
                                We offer a flexible manufacturing solution, from small batches to large-scale production, to meet the specific needs of each brand.  
                                <br /><br />
                                Whether white label or custom development, our expertise guarantees optimum quality and efficacy for your cosmetics.
                            </p>
                            <img className="liposome_choice-leftBloc-img" src={left_schema} />
                        </div>
                        <div className="liposome_choice-rightBloc-contaienr">
                            <h4 className="liposome_choice-rightBloc-title">Commitment to quality <br />
                                and recognised certifications
                            </h4>
                            <p className="liposome_choice-rightBloc-text">Our standards guarantee complete traceability, from the selection of raw materials to the final product.
                                <br /><br />
                                Our niosome cosmetics have been awarded international certifications attesting to our commitment to quality (ISO 9001, Form COS-8, Vegan, etc.).
                            </p>
                        </div>
                    </div>
                    <div className="liposome_choice_bottomBloc-container">
                        <div className="liposome_choice_bottomBloc-description-container">
                            <h4 className="liposome_choice_bottomBloc-description-title">Full assistance <label className="orange-color">from <br/> formulation to market launch</label></h4>
                            <p className="liposome_choice_bottomBloc-description-text">Our laboratory is not limited to production: we support our customers at  every stage of their project, from the initial formulation right through to market launch.
                                <br /><br />
                                Our service also includes regulatory monitoring and packaging assistance, ensuring that your food supplements are both compliant and appealing for fast and effective launch on the market.
                            </p>
                        </div>
                        <img className="liposome_choice_bottomBloc-description-img" src={bottom_schema} />
                    </div>
                </section>
                <MoreInfo
                    label={"Contact us"}
                    link={"*"}
                />
                <section className='formule_otherProduct_global-container'>
                    <h3 className='formule_otherCategory-title'><label className='bold'>our other</label><label className='orange-color'> ingredient categories</label></h3>
                    <OtherProduct
                        title1={"probiotiques & postbiotiques"}
                        subtitle1={"VPRO® and PROLIPO® Technologies "}
                        img1={probiotique}
                        link1={"/niosomes"}
                        title2={"Liposomes"}
                        subtitle2={"Plant extracts Vitamins · Minerals"}
                        img2={liposome}
                        link2={"/liposomes"}
                    />
                </section>
            </div>
        </div>
    );

}